import {
    BsEnvelope,
    BsEnvelopeOpen,
    BsWhatsapp,
    BsSticky,
    BsCardHeading,
    BsFileText,
    BsPeople,
    BsTelephone,
    BsClipboard2Check,
    BsEnvelopePaper,
} from "react-icons/bs";
import { Instagram, MessageCircle } from "react-feather";

type commIconProps = {
    type: string;
    unread?: boolean | undefined;
    className?: string | undefined;
    inBound?: boolean | undefined;
    title?: string;
};

function commIcon(props: commIconProps) {
    if (props.type == "Email") {
        return props.inBound ? (
            props.unread ? (
                <BsEnvelope
                    className={props.className}
                    title={props.title}
                />
            ) : (
                <BsEnvelopeOpen
                    className={props.className}
                    title={props.title}
                />
            )
        ) : (
            <BsEnvelopePaper
                className={props.className}
                title={props.title}
            />
        );
    }
    if (props.type == "Note")
        return (
            <BsSticky
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Task")
        return (
            <BsClipboard2Check
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Phone Old")
        return (
            <BsTelephone
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Facsimile")
        return (
            <BsCardHeading
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Meeting")
        return (
            <BsPeople
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Letter")
        return (
            <BsFileText
                className={props.className}
                title={props.title}
            />
        );
    if (props.type == "Phone")
        return (
            <BsTelephone
                className={props.className}
                title={props.title}
            />
        );

    if (props.type == "Instagram") return <Instagram className={props.className} />;
    if (props.type == "Whatsapp")
        return (
            <BsWhatsapp
                className={props.className}
                title={props.title}
            />
        );
    // default
    return <MessageCircle className={props.className} />;
}

export default commIcon;
